import { render, staticRenderFns } from "./cards-posts-list.vue?vue&type=template&id=552c9788&"
import script from "./cards-posts-list.vue?vue&type=script&lang=js&"
export * from "./cards-posts-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552c9788')) {
      api.createRecord('552c9788', component.options)
    } else {
      api.reload('552c9788', component.options)
    }
    module.hot.accept("./cards-posts-list.vue?vue&type=template&id=552c9788&", function () {
      api.rerender('552c9788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/post/cards-posts-list.vue"
export default component.exports